export default {
	APP_GREETING: {
		en: "Tell us a little bit about your business.",
		es: "Cuéntanos un poco sobre tu negocio."
	},
	APP_SUBHEADING: {
		en: "Fill out our 2 minute application and get an approval instantly.",
		es:
			"Complete nuestra solicitud de 2 minutos y obtenga una aprobación al instante."
	},
	GET_STARTED_HEADING: {
		en: "Start your application.",
		es: "Empezar"
	},
	HEADER_BASIC_INFORMATION: {
		en: "Basic Information",
		es: "Información Básica"
	},
	HEADER_OWNERSHIP: {
		en: "Ownership",
		es: "Propiedad"
	},
	HEADER_FINANCES: {
		en: "Finances",
		es: "Finanzas"
	},
	// BASIC_INFO_ELIGIBILITY: {
	// 	en: "Check your business's eligibility without impacting your credit.",
	// 	es: "Revise si su negocio cumple los requisitos sin impactar su crédito"
	// },
	BASIC_INFO_QUESTION_CASH: {
		en: "How much cash do you need?",
		es: "Cuanto dinero necesita?"
	},
	BASIC_INFO_LEGAL_NAME: {
		en: "Legal Business Name",
		es: "Nombre Legal del Negocio"
	},
	BASIC_INFO_CLASSIFICATION: {
		en: "Business Classification",
		es: "Clasificación del Negocio"
	},
	BASIC_INFO_ADDRESS: {
		en: "Physical Business Address (No P.O. Boxes)",
		es: "Domicilio del Negocio"
	},
	BASIC_INFO_CITY: {
		en: "City",
		es: "Ciudad"
	},
	BASIC_INFO_STATE: {
		en: "State",
		es: "Estado"
	},
	BASIC_INFO_ZIP_CODE: {
		en: "Zip Code",
		es: "Código Postal"
	},
	BASIC_INFO_REFER: {
		en: "How did you hear about us?",
		es: "Cómo se enteró de Cardiff?"
	},
	BASIC_INFO_SMS_CONSENT: {
		en: "SMS Consent",
		es: "Consentimiento DE SMS"
	},
	BASIC_INFO_APPLICATION_AGREEMENT: {
		en: "Cardiff Application Agreement",
		es: "Acuerdo de Aplicacion de Cardiff"
	},
	BASIC_INFO_E_SIGNATURE_AGREEMENT: {
		en: "E-Sign Consent Agreement",
		es: "Acuerdo de Consentimiento de Firma Electrónica"
	},
	BASIC_INFO_CONTINUE_TEXT: {
		en: "Continue",
		es: "Continuar"
	},
	BASIC_INFO_AGREEMENT_TO: {
		en: "I agree to the",
		es: "Estoy de acuerdo con el"
	},
	BASIC_INFO_AND: {
		en: "and",
		es: "y"
	}
};
